import React from "react";

interface SectionProps {
  title?: string;
  children: React.ReactNode;
  darkBackground?: boolean;
  border?: boolean;
  compact?: boolean;
  titleSize?: "sm" | "md" | "lg";
  className?: string;
  titleClassName?: string;
  contentClassName?: string;
}

const Section: React.FC<SectionProps> = ({
  title,
  children,
  darkBackground = false,
  border = true,
  compact = false,
  titleSize = "md",
  className = "",
  titleClassName = "",
  contentClassName = "",
}) => {
  const titleSizeClasses = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-2xl",
  };

  return (
    <section
      className={`
        ${darkBackground ? "bg-gray-50" : "bg-white"}
        ${border ? "border border-gray-200 shadow-sm" : ""}
        ${compact ? "my-1" : "my-2"}
        ${compact ? "py-4" : "py-10"}
        rounded-lg
        ${className}
      `}
    >
      <div className={`container mx-auto px-4"}`}>
        <div className={compact ? "space-y-3" : "space-y-4"}>
          {title && (
            <h3
              className={`
              ${titleSizeClasses[titleSize]}
              font-semibold
              text-gray-800
              ${titleClassName}
            `}
            >
              {title}
            </h3>
          )}
          <div className={contentClassName}>{children}</div>
        </div>
      </div>
    </section>
  );
};

export default Section;
